<template>
<div class="chapter">
<div class="inner_page">
<p class="SP"> </p>
<p class="IMG1"><img alt="image" height="250" src="images/author-photo.jpg" width="200"/></p>
<p class="TNI-2"><span class="ePub-I">The author at age seventeen</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter.vue?7a539493